export default __webpack_public_path__ + "static/media/assetSummary.cc9da05b.png";